import script from "./VTTargetsTable.vue?vue&type=script&lang=js"
export * from "./VTTargetsTable.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__